var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('questionSettingTemplate',{attrs:{"typeText":""}},[_c('p',{staticClass:"p20 ta_c"},[_vm._v("请点击左侧的组件开始设置题目把")])])}
var staticRenderFns = []

export { render, staticRenderFns }